import React from "react";
import PropTypes from "prop-types";

import Strf from "shared/components/Strf";

// Show this when user is inactive.
const InactiveBannerMessage = ({ name }) => (
	<Strf vars={{
		thumbsDown: (
			<span role="img" aria-label="thumbs down">👎</span>
		),
		name,
	}}>
		$thumbsDown $name no longer has an account.
	</Strf>
);
InactiveBannerMessage.propTypes = {
	name: PropTypes.string.isRequired,
};

export default InactiveBannerMessage;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/Banners/InactiveBanner.jsx